module.exports = __webpack_public_path__ + "img/password-view.2dc171dd.svg";